<ng-container
  *ngIf="{
    albaran: albaran,
    carrito: carritoDevolucion$ | async
  } as o"
>
  <div class="Imprimir">
    <div class="tituloInt tituloVentas">
      {{ 'DEVOLUCION_PARCIAL' | translateV2:'CAPITALIZE' }} # {{ o.albaran.TPVId }}/ {{ o.albaran.NumVenta }}
      ({{ o.albaran.NumEntradas }} {{ 'ENTRADAS' | translateV2:'LOWER' }})
    </div>

    <div class="ticket-info localiza-info">
      <div class="inputControl" [formGroup]="busquedaForm">
        <input
          [disabled]="deshabilitarFiltro"
          category="FILTER"
          (focus)="focusValue($event)"
          formControlName="query"
          class="localizador"
          type="text"
          placeholder="{{ 'FILTRAR_NUM_TICKETS' | translateV2:'CAPITALIZE' }}"
        />
        <img
          class="svg"
          src="assets/img/icon-search.svg"
          alt="icono busqueda"
        />
        <div class="close">
          <a title="cerrar"
            ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
          >
        </div>
      </div>
      <div class="onoffswitch-wrapGeneral">
        <div class="onoffswitch-wrap">
          <div class="onoffswitch">
            <input
              #checkAllSwitch
              type="checkbox"
              (change)="checkAllEntradas($event)"
              name="onoffswitch04"
              id="myonoffswitch04"
              class="onoffswitch-checkbox"
              [checked]="deshabilitarFiltro"
            />
            <label class="onoffswitch-label" for="myonoffswitch04"></label>
          </div>
          <label class="onoffswitch-label-text" for="myonoffswitch04"
            >{{ 'DEVOLVER_TODAS' | translateV2 }}</label
          >
        </div>
      </div>
    </div>

    <div class="ResumenResultado">
      <span *ngIf="selectedItems.length > 0"
        >{{ selectedItems.length }} {{ 'PRODUCTOS_SELECCIONADOS' | translateV2:'LOWER' }}</span
      >
    </div>

    <div class="Listadoresultado">
      <div class="Header">
        <div>{{ 'PRODUCTO' | translateV2 }}</div>
        <div class="hidden"></div>
        <div>{{ 'TICKET' | translateV2 }}</div>
      </div>

      <div class="checkboxStyledWrap">
        <ng-container *ngFor="let item of pagedItems; index as i">
          <div class="checkboxStyled">
            <div class="center">
              <label class="label" for="{{ item.id || item.TicketsGestion }}">
                <input
                  [disabled]="item.yaDevuelto"
                  class="label__checkbox"
                  [checked]="isChecked(item)"
                  (change)="checkEntrada($event, item)"
                  type="checkbox"
                  id="{{ item.id || item.TicketsGestion }}"
                />

                <span *ngIf="item.yaDevuelto" class="label__check devuelta">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
                <span *ngIf="!item.yaDevuelto" class="label__check">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
              </label>
            </div>
            <label class="label__text" for="{{ item.id || item.TicketsGestion }}">
              <span class="sub-wrap">
                <span class="sub-tit">{{ item.itemInfo?.NombrePantalla || item.NombreProducto }}</span>
              </span>
              <span class="number">{{ item.TicketsRango || (item.id || item.TicketsGestion) }}</span>
            </label>
            <div style="display: none;">{{ (item.tickets && item.tickets[0] && item.tickets[0].TicketsGestion) || item.TicketsGestion }}</div>
          </div>
        </ng-container>
      </div>

      <ul class="pagination" *ngIf="pager && pager.pages">
        <ng-container>
          <li>
            <a (click)="setPage(pager.currentPage - 1)" title="Previo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono prev"
              />
            </a>
          </li>
          <li *ngFor="let page of pager.pages">
            <a
              (click)="setPage(page)"
              [ngClass]="{ active: pager.currentPage === page }"
              >{{ page }}</a
            >
          </li>
          <li>
            <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono next"
              />
            </a>
          </li>
        </ng-container>
      </ul>
    </div>

    <!--<div>
      {{selectedItems.length }}
      <div *ngIf="selectedItems.length > 0">
        <div class="horariosWrap" *ngFor="let item of o.carrito.entradas">
          <div class="panel panel-info">
            <div class="panel-body">
              <div class="horarios">
                  <div *ngFor="let sesion of albaran.AlbaranRecintos">
                  <div class="Rtable-cell horario-cell" *ngIf="sesion.Periodo && sesion.Periodo == '1' && sesion.ItemId == item.entrada.ItemId"> 
                    <div 
                    [ngClass]="{ 'Rtable-cell--content horario-content': isSelected(transferenciaInput) }"
                    (click) = "seleccionarSesion(sesion)"> {{sesion.FechaEntrada}} </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>-->

    <div class="ButtonWrap">
      <button
        [disabled]="selectedItems.length === 0 || pulsado"
        class="bordeAzulButton imprimir"
        (click)="devolver()"
        title="{{ 'DEVOLVER' | translateV2:'UPPER' }}"
      >
        {{ 'DEVOLVER' | translateV2:'UPPER' }}
        <span *ngIf="selectedItems.length > 0"
        >({{ selectedItems.length }})</span
        >
      </button>
    </div>
  </div>
</ng-container>
